import React, { FunctionComponent, useEffect, useState } from "react"
import { spaceSizes } from "../../../api/Definitions"
import Grid from "../../../components/Grid/Grid"
import SelectItem from "../../../components/Grid/SelectItem"
import PureImage from "../../../components/Image/PureImage"
import Loader from "../../../components/Loader/Loader"
import { eImageVersions } from "../../../definitions/Image"
import { iSpace, iSpacePreview, iSpaceQuery } from "../../../definitions/Space"
import { useData } from "../../../hooks/useData"
import { useImageUrl } from "../../../hooks/useImageUrl"
import { get } from "../../../store/data/actions"
import SpaceItem from "../../Spaces/Item"
import s from "../Exhibitions.less"

interface iProps {
  onChange?: (...event: any[]) => void
  value?: string
}

const ManageSpace: FunctionComponent<iProps> = ({ onChange, value }) => {
  const [selected, setSelected] = useState<iSpacePreview | undefined>()
  const [isLoading, setLoading] = useState(false)
  const { data, query, setQuery, loading } = useData<iSpaceQuery, iSpace>({
    link: "/v2/spaces",
    defaultQuery: { public: true },
    shouldPingForData: false,
  })

  const handleSelectSpace = (selected: iSpace) => {
    onChange && onChange(selected._id)
  }

  useEffect(() => {
    if (value) {
      setLoading(true)
      get<iSpacePreview>({
        link: "https://api.vrallart.com/v1/public-spaces-id/" + value,
        fullUrl: true,
      }).then((res) => {
        setLoading(false)
        setSelected(res)
      })
    }
  }, [value])

  const url = useImageUrl(eImageVersions.LWRegular, selected?.fileVersions)

  console.log(url)

  return (
    <>
      <div className="flex-grids">
        <div className="col-6 grid-wrap">
          <label>Select Space</label>
          {loading ? (
            <Loader />
          ) : (
            <Grid>
              {data.map((space) => (
                <SelectItem<iSpace>
                  key={space._id}
                  item={space}
                  isSelected={space._id === selected?._id}
                  onClick={handleSelectSpace}
                >
                  <SpaceItem {...space} />
                </SelectItem>
              ))}
            </Grid>
          )}
        </div>
        <div className="grid-separator"></div>
        <div className="col-6 grid-wrap">
          <label>Selected Space</label>
          {selected &&
            (isLoading ? (
              <Loader />
            ) : (
              <div className={s.manageSpace}>
                <PureImage src={url} />
                <div className={s.spaceHeader}>
                  <h3>{selected.title}</h3>
                  <h4>{selected.subtitle}</h4>
                  <p>{selected.about}</p>
                </div>
                <div className={s.spaceInfo}>
                  <div>
                    {selected.size && (
                      <div className={`${s.tableRow}`}>
                        <span className={s.tableLabel}>Size: </span>{" "}
                        <span>
                          {
                            spaceSizes.find((s) => s.value === selected.size)
                              ?.label
                          }
                        </span>
                      </div>
                    )}
                    {selected.style && (
                      <div className={`${s.tableRow}`}>
                        <span className={s.tableLabel}>Style: </span>
                        <span>{selected.style}</span>
                      </div>
                    )}
                    {selected.floorArea && (
                      <div className={`${s.tableRow}`}>
                        <span className={s.tableLabel}>Floor area: </span>
                        <span>{selected.floorArea}</span>
                      </div>
                    )}
                    {selected.wallLength && (
                      <div className={`${s.tableRow}`}>
                        <span className={s.tableLabel}>Wall length: </span>
                        <span>{selected.wallLength}</span>
                      </div>
                    )}
                    {selected.ceilingHeight && (
                      <div className={`${s.tableRow}`}>
                        <span className={s.tableLabel}>Ceiling height: </span>
                        <span>{selected.ceilingHeight}</span>
                      </div>
                    )}
                    {selected.roomNumber && (
                      <div className={`${s.tableRow}`}>
                        <span className={s.tableLabel}>Room number: </span>
                        <span>{selected.roomNumber}</span>
                      </div>
                    )}
                  </div>
                  {selected.floors && selected.floors.length > 0 && (
                    <ul>
                      <div className={s.tableRow}>
                        <span className={s.tableLabel}>Floors</span>
                      </div>
                      {selected.floors.map((f, index) => (
                        <li key={index}>{f}</li>
                      ))}
                    </ul>
                  )}
                  {selected.walls && selected.walls.length > 0 && (
                    <ul>
                      <div className={s.tableRow}>
                        <span className={s.tableLabel}>Walls</span>
                      </div>
                      {selected.walls.map((w, index) => (
                        <li key={index}>{w}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  )
}

export default ManageSpace
